function Price() {
      const pricingData = {
            BASIC: {
                  price_text: "1-100",
                  price: "9$",
                  price2_text: "101-499",
                  price2: "8$",
                  features: {
                        // ÇEKİM UYGULAMASI
                        "Tüm Telefonlarda Kullanılır": true,
                        "Akıllı Çekim klavuzu": true,
                        "360° Görüntü Derleyicisi": false,
                        "Eş zamanlı Çekim Yükleme": false,

                        // GÖRÜNTÜLEME
                        "Araç Dış": true,
                        "360° Çekim ve Görüntüleme": false,
                        "30 Adet Çekim ve Görüntüleme": true,
                        "Araçİçi": false,
                        "360° Çekim ve Görüntüle": false,
                        "Motor Çekimi": true,
                        "Bağaj Çekimi": true,
                        "Ön- Arka alt Alt Çekim": true,
                        "Üst Çekim": true,
                        "Detay çekim ve görüntüleme": false,
                        "Kaporta durum raporu gösterimi": false,

                        // ARACA ÖZEL WEB SAYFASI
                        "Yönetim Paneli": false,
                        "Araca Özel Yönetilebilir web sayfası": false,
                        "Arka plan silme": false,
                        "özelleştirilebilir arka fon": false,
                        "Değiştirilebilir arka fon": false,
                        "2 dk lık kolaj video": false,
                        "Vitrine Araç Ekleme Çıkarma": false,
                        "Araç Üzeri 360° Akıllı QR kod uygulaması": false,

                        // DESTEK
                        "bir yıl ücretsiz yedekleme": false,
                        "Sistem Kurulumu ve Güncelleme": false,

                        // MECRALAR
                        "Satış Mecraları için Fotoğraf Galerisi": false,
                        "Whatsapp Gönderimi": true,
                        "Youtube İçin video": false,
                        "Sosyal Medya Paylaşım İçeriği": false,
                        "Tüm internet": false,

                        // EXPERTİSE
                        "52 Noktadan detaylı dış kusur çekimi": false,
                        "10 adet planlı Kusurlu alan çekimi": false,
                        "10 adet serbest kusurlu alan çekimi": false,
                        "Kaporta durum raporu oluşturma": false,
                        "Expertis raporu ( Pdf)": false,

                        // İŞLETMEYE ÖZEL WEB SAYFASI
                        "Mobil uyumlu": false,
                        "Yönetilebilir": false,
                        "İşletme 360° Çekimi ve Sanal gezinti": false,
                        "Google Mecralarda 360°gösterimi": false,
                        "Firmaya özel Araç Satış Vitrini": false,
                        "Ana satış vitrine Araç Çıkarma": false,
                        "MEKAN360 üyeliği": false,
                        "Sosyal Medya Takipçi kartı": false,
                        "360° Akıllı QR kod uygulaması": false,

                        // PROFESYONEL
                        "Kendi Özel Sayfasında Api Kullanımı": false,
                        "Sistemin Başka Marka Olarak Özelleşmesi": false
                  }
            },
            SILVER: {
                  price_text: "500-1.000",
                  price: "7$",
                  price2_text: "1.000-5.000",
                  price2: "6$",
                  features: {
                        // ÇEKİM UYGULAMASI
                        "Tüm Telefonlarda Kullanılır": true,
                        "Akıllı Çekim klavuzu": true,
                        "360° Görüntü Derleyicisi": true,
                        "Eş zamanlı Çekim Yükleme": true,

                        // GÖRÜNTÜLEME
                        "Araç Dış": true,
                        "360° Çekim ve Görüntüleme": true,
                        "30 Adet Çekim ve Görüntüleme": true,
                        "Araçİçi": true,
                        "360° Çekim ve Görüntüle": true,
                        "Motor Çekimi": true,
                        "Bağaj Çekimi": true,
                        "Ön- Arka alt Alt Çekim": true,
                        "Üst Çekim": true,
                        "Detay çekim ve görüntüleme": false,
                        "Kaporta durum raporu gösterimi": false,

                        // ARACA ÖZEL WEB SAYFASI
                        "Yönetim Paneli": false,
                        "Araca Özel Yönetilebilir web sayfası": false,
                        "Arka plan silme": false,
                        "özelleştirilebilir arka fon": false,
                        "Değiştirilebilir arka fon": false,
                        "2 dk lık kolaj video": false,
                        "Vitrine Araç Ekleme Çıkarma": false,
                        "Araç Üzeri 360° Akıllı QR kod uygulaması": false,

                        // DESTEK
                        "bir yıl ücretsiz yedekleme": false,
                        "Sistem Kurulumu ve Güncelleme": false,

                        // MECRALAR
                        "Satış Mecraları için Fotoğraf Galerisi": true,
                        "Whatsapp Gönderimi": true,
                        "Youtube İçin video": false,
                        "Sosyal Medya Paylaşım İçeriği": false,
                        "Tüm internet": false,

                        // EXPERTİSE
                        "52 Noktadan detaylı dış kusur çekimi": false,
                        "10 adet planlı Kusurlu alan çekimi": false,
                        "10 adet serbest kusurlu alan çekimi": false,
                        "Kaporta durum raporu oluşturma": false,
                        "Expertis raporu ( Pdf)": false,

                        // İŞLETMEYE ÖZEL WEB SAYFASI
                        "Mobil uyumlu": false,
                        "Yönetilebilir": false,
                        "İşletme 360° Çekimi ve Sanal gezinti": false,
                        "Google Mecralarda 360°gösterimi": false,
                        "Firmaya özel Araç Satış Vitrini": false,
                        "Ana satış vitrine Araç Çıkarma": false,
                        "MEKAN360 üyeliği": false,
                        "Sosyal Medya Takipçi kartı": false,
                        "360° Akıllı QR kod uygulaması": false,

                        // PROFESYONEL
                        "Kendi Özel Sayfasında Api Kullanımı": false,
                        "Sistemin Başka Marka Olarak Özelleşmesi": false
                  }
            },
            GOLD: {
                  price_text: "5.000-10.000",
                  price: "5$",
                  price2_text: "10.000-25.000",
                  price2: "4$",
                  features: {
                        // ÇEKİM UYGULAMASI
                        "Tüm Telefonlarda Kullanılır": true,
                        "Akıllı Çekim klavuzu": true,
                        "360° Görüntü Derleyicisi": true,
                        "Eş zamanlı Çekim Yükleme": true,

                        // GÖRÜNTÜLEME
                        "Araç Dış": true,
                        "360° Çekim ve Görüntüleme": true,
                        "30 Adet Çekim ve Görüntüleme": true,
                        "Araçİçi": true,
                        "360° Çekim ve Görüntüle": true,
                        "Motor Çekimi": true,
                        "Bağaj Çekimi": true,
                        "Ön- Arka alt Alt Çekim": true,
                        "Üst Çekim": true,
                        "Detay çekim ve görüntüleme": true,
                        "Kaporta durum raporu gösterimi": true,

                        // ARACA ÖZEL WEB SAYFASI
                        "Yönetim Paneli": true,
                        "Araca Özel Yönetilebilir web sayfası": true,
                        "Arka plan silme": true,
                        "özelleştirilebilir arka fon": true,
                        "Değiştirilebilir arka fon": true,
                        "2 dk lık kolaj video": true,
                        "Vitrine Araç Ekleme Çıkarma": true,
                        "Araç Üzeri 360° Akıllı QR kod uygulaması": false,

                        // DESTEK
                        "bir yıl ücretsiz yedekleme": false,
                        "Sistem Kurulumu ve Güncelleme": false,

                        // MECRALAR
                        "Satış Mecraları için Fotoğraf Galerisi": true,
                        "Whatsapp Gönderimi": true,
                        "Youtube İçin video": true,
                        "Sosyal Medya Paylaşım İçeriği": true,
                        "Tüm internet": true,

                        // EXPERTİSE
                        "52 Noktadan detaylı dış kusur çekimi": false,
                        "10 adet planlı Kusurlu alan çekimi": false,
                        "10 adet serbest kusurlu alan çekimi": false,
                        "Kaporta durum raporu oluşturma": false,
                        "Expertis raporu ( Pdf)": false,

                        // İŞLETMEYE ÖZEL WEB SAYFASI
                        "Mobil uyumlu": false,
                        "Yönetilebilir": false,
                        "İşletme 360° Çekimi ve Sanal gezinti": false,
                        "Google Mecralarda 360°gösterimi": false,
                        "Firmaya özel Araç Satış Vitrini": false,
                        "Ana satış vitrine Araç Çıkarma": false,
                        "MEKAN360 üyeliği": false,
                        "Sosyal Medya Takipçi kartı": false,
                        "360° Akıllı QR kod uygulaması": false,

                        // PROFESYONEL
                        "Kendi Özel Sayfasında Api Kullanımı": false,
                        "Sistemin Başka Marka Olarak Özelleşmesi": false
                  }
            },
            PRO: {
                  price_text: "25.000-50.000",
                  price: "3$",
                  price2_text: "50.000-100.000",
                  price2: "2$",
                  features: {
                        // ÇEKİM UYGULAMASI
                        "Tüm Telefonlarda Kullanılır": true,
                        "Akıllı Çekim klavuzu": true,
                        "360° Görüntü Derleyicisi": true,
                        "Eş zamanlı Çekim Yükleme": true,

                        // GÖRÜNTÜLEME
                        "Araç Dış": true,
                        "360° Çekim ve Görüntüleme": true,
                        "30 Adet Çekim ve Görüntüleme": true,
                        "Araçİçi": true,
                        "360° Çekim ve Görüntüle": true,
                        "Motor Çekimi": true,
                        "Bağaj Çekimi": true,
                        "Ön- Arka alt Alt Çekim": true,
                        "Üst Çekim": true,
                        "Detay çekim ve görüntüleme": true,
                        "Kaporta durum raporu gösterimi": true,

                        // ARACA ÖZEL WEB SAYFASI
                        "Yönetim Paneli": true,
                        "Araca Özel Yönetilebilir web sayfası": true,
                        "Arka plan silme": true,
                        "özelleştirilebilir arka fon": true,
                        "Değiştirilebilir arka fon": true,
                        "2 dk lık kolaj video": true,
                        "Vitrine Araç Ekleme Çıkarma": true,
                        "Araç Üzeri 360° Akıllı QR kod uygulaması": true,

                        // DESTEK
                        "bir yıl ücretsiz yedekleme": true,
                        "Sistem Kurulumu ve Güncelleme": true,

                        // MECRALAR
                        "Satış Mecraları için Fotoğraf Galerisi": true,
                        "Whatsapp Gönderimi": true,
                        "Youtube İçin video": true,
                        "Sosyal Medya Paylaşım İçeriği": true,
                        "Tüm internet": true,

                        // EXPERTİSE
                        "52 Noktadan detaylı dış kusur çekimi": true,
                        "10 adet planlı Kusurlu alan çekimi": true,
                        "10 adet serbest kusurlu alan çekimi": true,
                        "Kaporta durum raporu oluşturma": true,
                        "Expertis raporu ( Pdf)": true,

                        // İŞLETMEYE ÖZEL WEB SAYFASI
                        "Mobil uyumlu": true,
                        "Yönetilebilir": true,
                        "İşletme 360° Çekimi ve Sanal gezinti": true,
                        "Google Mecralarda 360°gösterimi": true,
                        "Firmaya özel Araç Satış Vitrini": true,
                        "Ana satış vitrine Araç Çıkarma": true,
                        "MEKAN360 üyeliği": true,
                        "Sosyal Medya Takipçi kartı": true,
                        "360° Akıllı QR kod uygulaması": true,

                        // PROFESYONEL
                        "Kendi Özel Sayfasında Api Kullanımı": false,
                        "Sistemin Başka Marka Olarak Özelleşmesi": false
                  }
            },
            ENTERPRISE: {
                  price_text: "100.000+",
                  price: "1$",
                  price2: "",
                  features: {
                        // ÇEKİM UYGULAMASI
                        "Tüm Telefonlarda Kullanılır": true,
                        "Akıllı Çekim klavuzu": true,
                        "360° Görüntü Derleyicisi": true,
                        "Eş zamanlı Çekim Yükleme": true,

                        // GÖRÜNTÜLEME
                        "Araç Dış": true,
                        "360° Çekim ve Görüntüleme": true,
                        "30 Adet Çekim ve Görüntüleme": true,
                        "Araçİçi": true,
                        "360° Çekim ve Görüntüle": true,
                        "Motor Çekimi": true,
                        "Bağaj Çekimi": true,
                        "Ön- Arka alt Alt Çekim": true,
                        "Üst Çekim": true,
                        "Detay çekim ve görüntüleme": true,
                        "Kaporta durum raporu gösterimi": true,

                        // ARACA ÖZEL WEB SAYFASI
                        "Yönetim Paneli": true,
                        "Araca Özel Yönetilebilir web sayfası": true,
                        "Arka plan silme": true,
                        "özelleştirilebilir arka fon": true,
                        "Değiştirilebilir arka fon": true,
                        "2 dk lık kolaj video": true,
                        "Vitrine Araç Ekleme Çıkarma": true,
                        "Araç Üzeri 360° Akıllı QR kod uygulaması": true,

                        // DESTEK
                        "bir yıl ücretsiz yedekleme": true,
                        "Sistem Kurulumu ve Güncelleme": true,

                        // MECRALAR
                        "Satış Mecraları için Fotoğraf Galerisi": true,
                        "Whatsapp Gönderimi": true,
                        "Youtube İçin video": true,
                        "Sosyal Medya Paylaşım İçeriği": true,
                        "Tüm internet": true,

                        // EXPERTİSE
                        "52 Noktadan detaylı dış kusur çekimi": true,
                        "10 adet planlı Kusurlu alan çekimi": true,
                        "10 adet serbest kusurlu alan çekimi": true,
                        "Kaporta durum raporu oluşturma": true,
                        "Expertis raporu ( Pdf)": true,

                        // İŞLETMEYE ÖZEL WEB SAYFASI
                        "Mobil uyumlu": true,
                        "Yönetilebilir": true,
                        "İşletme 360° Çekimi ve Sanal gezinti": true,
                        "Google Mecralarda 360°gösterimi": true,
                        "Firmaya özel Araç Satış Vitrini": true,
                        "Ana satış vitrine Araç Çıkarma": true,
                        "MEKAN360 üyeliği": true,
                        "Sosyal Medya Takipçi kartı": true,
                        "360° Akıllı QR kod uygulaması": true,

                        // PROFESYONEL
                        "Kendi Özel Sayfasında Api Kullanımı": true,
                        "Sistemin Başka Marka Olarak Özelleşmesi": true
                  }
            }
      };

      // Get all unique features and categories
      const categories = {};
      Object.values(pricingData).forEach(plan => {
            Object.entries(plan.features).forEach(([feature, value]) => {
                  // Find category from comments in the original data
                  let category = "Diğer";
                  if (feature.includes("Çekim")) category = "ÇEKİM UYGULAMASI";
                  else if (feature.includes("Araç") || feature.includes("Motor") || feature.includes("Bağaj")) category = "GÖRÜNTÜLEME";
                  else if (feature.includes("web") || feature.includes("Yönetim")) category = "ARACA ÖZEL WEB SAYFASI";
                  else if (feature.includes("yedekleme") || feature.includes("Güncelleme")) category = "DESTEK";
                  else if (feature.includes("Mecra") || feature.includes("internet") || feature.includes("Whatsapp")) category = "MECRALAR";
                  else if (feature.includes("kusur") || feature.includes("Expertis")) category = "EXPERTİSE";
                  else if (feature.includes("Mobil") || feature.includes("İşletme")) category = "İŞLETMEYE ÖZEL WEB SAYFASI";
                  else if (feature.includes("Api") || feature.includes("Marka")) category = "PROFESYONEL";

                  if (!categories[category]) {
                        categories[category] = new Set();
                  }
                  categories[category].add(feature);
            });
      });

      return (
            <div className="pricing-section" style={{ padding: "8rem 0" }}>
                  <div className="container">
                        <div style={{
                              textAlign: "center",
                              fontSize: "3rem",
                              marginBottom: "4rem",
                              border: "1px solid #e0e0e0",
                              padding: "2rem",
                              borderRadius: "8px",
                              backgroundColor: "#fff",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}>Price Plans</div>

                        {/* Plan headers */}
                        <div style={{
                              display: "grid",
                              gridTemplateColumns: "2fr repeat(5, 1fr)",
                              gap: "1rem",
                              marginBottom: "2rem",
                              position: "sticky",
                              top: "0",
                              backgroundColor: "#fff",
                              zIndex: "100",
                              padding: "1rem 0"
                        }}>
                              <div style={{
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                    padding: "1rem"
                              }}></div>
                              {Object.entries(pricingData).map(([plan, data]) => (
                                    <div key={plan} style={{
                                          textAlign: "center",
                                          border: "1px solid #e0e0e0",
                                          borderRadius: "8px",
                                          padding: "1rem",
                                          backgroundColor: "#fff",
                                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                    }}>
                                          <h3 style={{ fontSize: "2rem", marginBottom: "1rem" }}>{plan}</h3>
                                          <div style={{ fontSize: "1.6rem", fontWeight: "bold", color: "#ff4d30" }}>
                                                <div>{data.price_text}</div>
                                                <div>{data.price}</div>
                                                {data.price2 && (
                                                      <>
                                                            <div>{data.price2_text}</div>
                                                            <div>{data.price2}</div>
                                                      </>
                                                )}
                                          </div>
                                    </div>
                              ))}
                        </div>

                        {/* Features by category */}
                        {Object.entries(categories).map(([category, features]) => (
                              <div key={category}>
                                    <div style={{
                                          fontSize: "2rem",
                                          marginTop: "3rem",
                                          marginBottom: "2rem",
                                          padding: "1rem",
                                          border: "1px solid #e0e0e0",
                                          borderRadius: "8px",
                                          backgroundColor: "#f8f9fa",
                                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                    }}>{category}</div>

                                    {Array.from(features).map(feature => (
                                          <div key={feature} style={{
                                                display: "grid",
                                                gridTemplateColumns: "2fr repeat(5, 1fr)",
                                                gap: "1rem",
                                                marginBottom: "1rem"
                                          }}>
                                                <div style={{
                                                      border: "1px solid #e0e0e0",
                                                      borderRadius: "8px",
                                                      padding: "1rem",
                                                      backgroundColor: "#fff"
                                                }}>{feature}</div>
                                                {Object.values(pricingData).map((plan, index) => (
                                                      <div key={index} style={{
                                                            textAlign: "center",
                                                            border: "1px solid #e0e0e0",
                                                            borderRadius: "8px",
                                                            padding: "1rem",
                                                            backgroundColor: "#fff"
                                                      }}>
                                                            {plan.features[feature] ?
                                                                  <span style={{ color: "green", fontSize: "1.6rem" }}>✓</span> :
                                                                  <span style={{ color: "red", fontSize: "1.6rem" }}>✗</span>
                                                            }
                                                      </div>
                                                ))}
                                          </div>
                                    ))}
                              </div>
                        ))}
                  </div>
            </div>
      );
}

export default Price;